import { Injectable } from '@angular/core';
import type { EmailQueryInterface } from '@zaoblako/shared/common/dtos/email-query.dto';
import type { ProfileTestEmailFindInterface } from '@zaoblako/shared/modules/security/dtos/profile/profile-test-email-find.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PersonalAccountProfileService extends BaseService {
  protected baseUrl = '/personal-account/security/profile';

  public testEmail(email: EmailQueryInterface): Observable<ProfileTestEmailFindInterface> {
    return this.http.get<ProfileTestEmailFindInterface>(`${this.baseUrl}/test-email`, {
      params: this.objectToHttpParams(email)
    });
  }
}
